export default "__VITE_ASSET__345b1473__"